// #region Global Imports
import * as React from "react";
// #endregion Global Imports

export const DeviceContext = React.createContext("");
